module.exports = __webpack_public_path__ + "static/media/jupiter.e9dae8d7.png";